// extracted by mini-css-extract-plugin
module.exports = {"root":"BigQuote_root__OIi_J","quote":"BigQuote_quote__BaTxE","attribution":"BigQuote_attribution__LcTva"};